module.exports = __webpack_public_path__ + "img/thumbnail_Gemsbok_m_albino.b58d1c06.png";